const routes = [
    {
      path: '/reportdesigner',
      name: 'reportdesigner',
      meta: {
        isAuthRequired: true
      },
      component: () => import('@/views/ReportDesigner.vue')
    },
    {
      path: '/reports',
      name: 'reports',
      meta: {
        isAuthRequired: true
      },
      component: () => import('@/views/ReportViewer.vue')
    }
  ]

  export default routes
